import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchBlogsRandom5 } from "../../../api/blogsAPI";

const RecentBlogs = () => {
  const [otherBlogs, setOtherBlogs] = useState([]);
  const { blogId } = useParams();

  useEffect(() => {
    const getBlogs = async () => {
      try {
        const blogData = await fetchBlogsRandom5();
        if (Array.isArray(blogData)) {
          const filtered = blogData.filter(
            (b) => b.id !== parseInt(blogId)
          );
          const sorted = filtered.sort((a, b) => b.id - a.id).slice(0, 6);
          setOtherBlogs(sorted);
        }
      } catch (error) {
        console.error("Failed to fetch recent blogs:", error);
      }
    };
    getBlogs();
  }, [blogId]);

  return (
    <div>
      <div className="flex items-center gap-2 mb-5">
        <span className="w-1.5 h-6 rounded-full bg-gradient-to-b from-brand-500 to-eco-500" />
        <h3 className="font-oswald text-xl font-semibold text-slate-900">
          Artikel Terbaru
        </h3>
      </div>

      <ul className="space-y-1 list-none p-0">
        {otherBlogs.map((blog, idx) => (
          <li key={blog.id}>
            <Link
              to={`/blog/${blog.id}`}
              className="group flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50 transition-colors no-underline hover:no-underline"
            >
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-gradient-to-br from-brand-100 to-eco-100 text-brand-700 flex items-center justify-center text-xs font-bold">
                {String(idx + 1).padStart(2, "0")}
              </span>
              <span className="text-sm text-slate-700 group-hover:text-brand-600 font-overpass leading-snug line-clamp-2 transition-colors">
                {blog.title}
              </span>
            </Link>
          </li>
        ))}
        {otherBlogs.length === 0 && (
          <li className="text-sm text-slate-400 font-overpass p-3">
            Memuat artikel...
          </li>
        )}
      </ul>
    </div>
  );
};

export default RecentBlogs;
